// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-popup-category-header[data-v-3c8f092e]{margin-top:16px;padding:8px 0 8px 17px;border-left:4px solid #333;font-weight:300;font-size:14px;line-height:172%;letter-spacing:.02em;color:#333}.event-popup-category-header__row[data-v-3c8f092e]{display:flex;align-items:center}.event-popup-category-header__icon[data-v-3c8f092e]{flex:none;height:15px;margin-right:9px}", ""]);
// Exports
module.exports = exports;
